export interface Questionnaire {
  version: string;
  steps: QuestionnaireStep[];
  successMessage: string;
}

interface QuestionnaireStep {
  items?: QuestionnaireItem[];
  cta?: QuestionnaireCta;
}

export type QuestionnaireItem = SatisfactionScoreItem | MultipleChoiceItem | FreetextItem | HeadingItem;
export type QuestionnaireCta = SingleButtonCta | YesNoCta;

export enum ItemType {
  Cta = 'cta',
  YesNoCta = 'yes-no-cta',
  SatisfactionScore = 'satisfation-score',
  MultipleChoice = 'multiple-choice',
  FreeText = 'free-text',
  Heading = 'heading',
}

export interface BasicItem {
  key: string;
  text: string;
  displayCondition?: DisplayCondition;
}

export interface SingleButtonCta extends BasicItem {
  type: ItemType.Cta;
}
export interface YesNoCta extends BasicItem {
  type: ItemType.YesNoCta;
  // options available are 'yes' and 'no'
}

export enum YesNoCtaValue {
  Yes = 'yes',
  No = 'no'
}

export interface DisplayCondition {
  reference: string;
  op: 'exists' | 'equals' | 'lt' | 'gt' | 'minLength' | 'maxLength';
  value?: string | number;
}

export interface SatisfactionScoreItem extends BasicItem {
  type: ItemType.SatisfactionScore;
  // options available are 'HAPPY', 'UNHAPPY' and 'NEUTRAL'
}

export enum SatisfactionScoreValue {
  Happy = 'HAPPY',
  Unhappy = 'UNHAPPY',
  Neutral = 'NEUTRAL',
}

export interface MultipleChoiceItem extends BasicItem {
  type: ItemType.MultipleChoice;
  options: string[];
}

export interface FreetextItem extends BasicItem {
  type: ItemType.FreeText;
}
export interface HeadingItem extends BasicItem {
  type: ItemType.Heading;
}

export interface GroupSessionFeedback {
  id: string;
  accountId: string;
  groupInstanceId: string;
  groupLeaderId: string;
  groupSessionId: string;
  answers: Array<{ score: number; description: string }> | Record<string, unknown>;
  version: string;
  dateCreated: Date;
  lastUpdated: Date;
}

export type GroupSessionFeedbackBasicInfo = Omit<GroupSessionFeedback, 'id' | 'dateCreated' | 'lastUpdated'>
